import styled from 'styled-components'
import Button from 'builder/components/Button'

export const ActionButton = styled(Button)`
  padding: 12px 24px;
`
